import Message from 'model/MessageTypes/Messages';
import MessageResponse from 'model/MessageTypes/Responses';

export default function (response: MessageResponse): Message {
  if ('type' in response && response.type === 'SharedProfile') {
    return {
      type: 'SharedProfile',
      message: response,
    };
  }

  if ('type' in response && response.type === 'SharedExperience') {
    return {
      type: 'SharedExperience',
      message: response,
    };
  }

  if ('type' in response && response.type === 'SharedLocation') {
    return {
      type: 'SharedLocation',
      message: response,
    };
  }

  if ('isCensored' in response) {
    return {
      type: 'ChatMessage',
      message: response,
    };
  }

  if ('review_id' in response && response.review_id) {
    return {
      type: 'ReviewUpdate',
      message: response,
    };
  }

  if ('type' in response) {
    if (
      response.type === 'ListedTripNotification' ||
      response.type === 'TripChangeNotification' ||
      response.type === 'CustomTripNotification'
    ) {
      return {
        type: 'BookingUpdate',
        message: response,
      };
    }
    if (
      response.type === 'NewCustomTripRequestClean' ||
      response.type === 'NewCustomTripRequestFromExperience'
    ) {
      return {
        type: 'PersonalizedOfferRequest',
        message: response,
      };
    }
  }

  if ('change' in response && response.change === 'CHANGEDATETIMEREQUEST') {
    return {
      type: 'RescheduleRequest',
      message: response,
    };
  }

  return {
    type: 'Unknown',
    message: response,
  };
}
